import React from 'react';
import Scrollspy from 'react-scrollspy';

export default function Navbar() {
  const navItems = [
    { name: 'Home', id: 'hero' },
    { name: 'About', id: 'about' },
    { name: 'Education', id: 'education' },
    { name: 'Experience', id: 'experience' },
    { name: 'Skills', id: 'skills' },
    { name: 'Publications', id: 'publications' },
    { name: 'Research', id: 'projects' },
    { name: 'Awards', id: 'awards' },
    { name: 'Extracurricular', id: 'extracurricular' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Contact', id: 'contact' },
  ];

  // Track ALL section ids
  const allSectionIds = navItems.map(item => item.id);

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow z-50 py-4 px-6">

      <Scrollspy
        items={allSectionIds}
        currentClassName="text-green-600 font-semibold"
        className="flex flex-wrap gap-4 justify-center"
        offset={-150}   // IMPORTANT: Adjusted for fixed navbar height
      >
        {navItems.map((item, index) => (
          <li key={index}>
            <a
              href={`#${item.id}`}
              className="transition-colors duration-200 hover:text-green-500"
            >
              {item.name}
            </a>
          </li>
        ))}
      </Scrollspy>

    </nav>
  );
}
